import { Space } from 'antd'
import AppDnD from 'general/components/AppDragAndDrop/AppDnD'
import CustomAntButton from 'general/components/Button/CustomAntButton'
import ContentContainer from 'general/components/ContentContainer'
import FilterPopover from 'general/components/CustomPopover/FilterPopover'
// import SelectOptions from 'general/constants/SelectOptions'
import Utils, { findObjectInArray } from 'general/utils/Utils'
import useFilter from 'hooks/useFilter'
// import { useMemo } from 'react'
import { InvoiceTable } from '../../components/InvoiceTable'
import Modals from '../../components/Modals'
import { defaultValues, filterOptions, renderInvoiceType } from '../../constant'
import useAppDnD from 'hooks/useAppDnD'
import useGetSerials from 'hooks/Queries/useGetSerials'
// import SelectOptions from 'general/constants/SelectOptions'
import CustomAntInput from 'general/components/Forms/CustomAntInput/CustomAntInput'
import CustomAntSelect from 'general/components/CustomAntSelect'
import { useEffect, useState } from 'react'
import useSearchDebounce from 'hooks/useSearchDebounce'
import {
  useCopyQueryListInvoice,
  useMutationPullBulkMessage,
  useQueryListCompany,
  useQueryListInvoice,
} from '../../components/queries'
import _ from 'lodash'
// import { useMutationGetBulkMessage } from 'features/Invoice/screens/ListInvoice/queries'
import { ActionsTable } from '../../components/InvoiceTable/ActionsTable'
import dayjs from 'dayjs'
import PreferenceKeys from 'general/constants/PreferenceKeys'
import { useAppSelector } from 'hooks/useRedux'
import { shallowEqual } from 'react-redux'
import { useTransactionSelector } from 'features/Invoice/screens/ListTransactions/slice'
import { useDispatch } from 'react-redux'
import { unwrapResult } from '@reduxjs/toolkit'
import { thunkFindJobposition } from 'features/Jobposition/jobpositionSlice'
import {
  thunkCopys,
  thunkChangeStatusRemoveInvoice,
} from 'features/Invoice/invoiceSlice'
import ToastHelper from 'general/helpers/ToastHelper'
import axiosClient from 'api/axiosClient'
import reportApi from 'api/reportApi'
import { saveAs } from 'file-saver'
import CustomDataTable from 'general/components/CustomDataTable'
import ModalCompanyConfigs from 'features/TvanHandle/components/ModalCompanyConfigs'
import TableAction from 'general/components/GroupButton/TableAction'
import { IconAction } from 'general/components/GroupButton/styles'
import ModalCompanyIsDataLog from 'features/TvanHandle/components/ModalCompanyIsDataLog'
import SelectOptions from 'general/constants/SelectOptions'
export const TvanHandleCompany = () => {
  // base state
  const [tvanState, setTvanState] = useState({ show: false, value: false })
  const [modalsState, setModalsState] = useState({})
  const [modalsStateLogBom, setModalsStateLogBom] = useState({})
  const [disableCopy, setDisableCopy] = useState(false)
  const [disableExport, setDisableExport] = useState(false)
  const [
    disableChangeStatusRemoveInvoice,
    setDisableChangeStatusRemoveInvoice,
  ] = useState(false)
  const [filterParams, setFilterParams] = useFilter(
    'TvanHandle',
    'gFiltersTvanHandle',
  )
  const { mutate: checkMessages, isPending: checkingBulkMessage } =
    useMutationPullBulkMessage()

  const defaultColumns = [
    {
      id: 'taxCode',
      name: 'Mã số thuế - CCCD',
      minWidth: '240px',
      center: true,
      omit: false,
      cell: (row) => {
        return (
          <p
            // style={{
            //   textAlign: 'center',
            // }}
            data-tag="allowRowEvents"
            className="text-dark-75 font-weight-normal m-0 text-maxline-3 w-100 "
          >
            {row?.taxCode} -{' '}
            <span style={{ color: 'blue' }}>{row?.identifyNumber}</span>
          </p>
        )
      },
    },
    {
      id: 'companyName',
      name: 'Tên doanh nghiệp',
      minWidth: '150px',
      center: true,
      omit: false,
      cell: (row) => {
        return (
          <p
            style={{
              textAlign: 'center',
            }}
            data-tag="allowRowEvents"
            className="text-dark-75 font-weight-normal m-0 text-maxline-3 w-100 "
          >
            {row?.companyName}
          </p>
        )
      },
    },
    // {
    //   id: 'companyPhone',
    //   name: 'Số điện thoại',
    //   minWidth: '120px',
    //   center: true,
    //   omit: false,
    //   cell: (row) => {
    //     return (
    //       <p
    //         style={{
    //           textAlign: 'center',
    //         }}
    //         data-tag="allowRowEvents"
    //         className="text-dark-75 font-weight-normal m-0 text-maxline-3 w-100 "
    //       >
    //         {`${row?.companyPhone ?? ''}`}
    //       </p>
    //     )
    //   },
    // },
    // {
    //   id: 'companyAddress',
    //   name: 'Địa chỉ',
    //   minWidth: '250px',
    //   center: true,
    //   omit: false,
    //   cell: (row) => {
    //     return (
    //       <p
    //         style={{
    //           textAlign: 'center',
    //         }}
    //         data-tag="allowRowEvents"
    //         className="text-dark-75 font-weight-normal m-0 text-maxline-3 w-100 "
    //       >
    //         {row?.companyAddress}
    //       </p>
    //     )
    //   },
    // },
    {
      id: 'typeSign',
      name: 'Loại chữ ký số',
      center: true,
      omit: false,
      cell: (row) => {
        return (
          <p
            data-tag="allowRowEvents"
            className="text-dark-75 font-weight-normal m-0 text-maxline-3 w-100 "
          >
            {row?.activeSigningMethod}
          </p>
        )
      },
    },
    {
      id: 'confixNameNull',
      name: 'Cấu hình HH không tên',
      center: true,
      omit: false,
      cell: (row) => {
        let data = findObjectInArray(
          companyConfigs,
          'companyId',
          row?.companyId,
        )
        return (
          <p
            data-tag="allowRowEvents"
            className="text-dark-75 font-weight-normal m-0 text-maxline-3 w-100 "
          >
            {data?.configNullNameGood}
          </p>
        )
      },
    },
    {
      id: 'isDataLog',
      name: 'Hiển thị logbom',
      center: true,
      omit: false,
      cell: (row) => {
        let data = findObjectInArray(
          SelectOptions.isDataLogs,
          'value',
          row?.isDataLog,
        )
        return (
          <p
            data-tag="allowRowEvents"
            className="text-dark-75 font-weight-normal m-0 text-maxline-3 w-100 "
          >
            {data?.label}
          </p>
        )
      },
    },
    {
      name: 'Hành động',
      center: true,
      disabled: true,
      compact: true,
      minWidth: '200px',
      grow: 2,
      style: {
        justifyContent: 'flex-end',
      },
      cell: (row) => {
        // 👇 xử lý logic ở đây
        let data = findObjectInArray(
          companyConfigs,
          'companyId',
          row?.companyId,
        )

        // 👇 sau đó return JSX
        return (
          <>
            <TableAction
              titleActionText="Cấu hình hàng hóa không tên"
              icon={<IconAction className="fa-solid fa-screwdriver" />}
              onClick={() => {
                setModalsState({
                  show: true,
                  value: { ...row, companyConfig: data },
                })
              }}
            />
            <TableAction
              titleActionText="Cấu hình hiển thị danh sách logbom"
              icon={<IconAction className="fa-solid fa-gas-pump" />}
              onClick={() => {
                setModalsStateLogBom({
                  show: true,
                  value: { ...row, companyConfig: data },
                })
              }}
            />
          </>
        )
      },
    },
  ]
  const dynamicColumns = useAppDnD(defaultColumns)

  const { clearSelectedRows, selectedRows } = useTransactionSelector()

  const handleChange = ({ key, value }) => {
    const cloneTvanState = { ...tvanState }
    cloneTvanState[key] = value
    setTvanState(cloneTvanState)
  }
  const handleChangeModalState = ({ key, value }) => {
    const cloneModasState = { ...modalsState }
    cloneModasState[key] = value
    setModalsState(cloneModasState)
  }
  // hiển thị
  // Gán dữ liệu ban đầu
  useEffect(() => {
    const cloneTvanState = { ...tvanState }
    cloneTvanState.keySearch =
      cloneTvanState.keySearch ?? filterOptions[0].value
    setTvanState(cloneTvanState)
  }, [])

  const dispatch = useDispatch()

  // lấy danh sách hóa đơn
  const { debouncedSearch, search, setSearch } = useSearchDebounce('')
  const {
    invoiceListData,
    total,
    copyData,
    companyConfigs,
    isGettingListData,
    isRefetching,
    refetchListInvoice,
  } = useQueryListCompany({
    ...filterParams,
    [tvanState.keySearch]: debouncedSearch,
    // [tvanState.keySearch]: tvanState.searchValue,
  })

  // Làm mới dữ liệu hóa đơn
  useEffect(() => {
    refetchListInvoice()
  }, [
    filterParams,
    refetchListInvoice,
    tvanState.keySearch,
    tvanState.searchValue,
    debouncedSearch,
  ])

  // const { data: dataCopys, copyRefetch } = useCopyQueryListInvoice({
  //   invoiceIds: [-1],
  // })

  const changeStatusRemoveInvoiceRefetch = async () => {
    setDisableChangeStatusRemoveInvoice(true)
    const invoiceIds = selectedRows.map((item) => item.invoiceId)
    const result = unwrapResult(
      await dispatch(thunkChangeStatusRemoveInvoice({ invoiceIds })),
    )
    setDisableChangeStatusRemoveInvoice(false)
    if (result?.result === 'success') {
      ToastHelper.showSuccess(
        `Cập nhật trạng thái đã xóa cho ${invoiceIds.length} hóa đơn thành công`,
      )
      refetchListInvoice()
    } else {
      ToastHelper.showError(
        `Cập nhật trạng thái đã xóa cho ${invoiceIds.length} hóa đơn thất bại`,
      )
    }
  }

  const buttonGroups = [
    {
      text: 'Nhân bản',
      icon: 'fa-light fa-check',
      color: '#3CC65E',
      onClick: () => {
        // copyRefetch()
      },
    },
    {
      text: 'Đổi trạng thái đã xóa',
      icon: 'fa-light fa-check',
      color: '#ee2334',
      onClick: () => {
        changeStatusRemoveInvoiceRefetch()
      },
    },
  ]

  const { selectedInvoices, toggledClearRows, modalStates } = useAppSelector(
    (state) => state.invoice,
    shallowEqual,
  )

  // Lọc
  // bảng
  // kéo mã
  // chuyển về gửi lỗi
  // cập nhật thông điệp
  return (
    <ContentContainer wrapperClassName={'list-issued-ticket'}>
      <ContentContainer.Header
        titleContent={'Danh sách doanh nghiệp'}
        toolBar={
          <Space className="d-flex">
            <AppDnD
              defaultColumns={defaultColumns}
              localStorageName={PreferenceKeys.TvanHandleCompany}
            />
          </Space>
        }
      />
      <Space className="ml-5">
        <Space>
          <CustomAntInput
            type="search"
            borderRadius="sm"
            width={150}
            inputProps={{
              value: search,
              onChange: (e) => {
                setSearch(e.target.value)
                // set page is 1 when search
                setFilterParams({ page: 1 })
              },
            }}
          />
          {/* <CustomAntSelect
            className="adjustReplaceTicket-select"
            options={filterOptions}
            placeholder="Chọn tiêu chí tìm kiếm"
            value={tvanState.keySearch}
            onChange={(val) => handleChange({ key: 'keySearch', value: val })}
          /> */}
        </Space>
        {/* <FilterPopover
          menuPosition="bottomLeft"
          defaultValues={defaultValues()}
          savedKey={'gFiltersTvanHandle'}
          onApply={setFilterParams}
        /> */}
      </Space>

      {/* toolBar=
        {
          <FilterPopover
            menuPosition="bottomLeft"
            defaultValues={defaultValues}
            savedKey={'gFiltersInvoiceList'}
            onApply={() => setFilterParams}
          />
        } */}
      {/* {renderInvoiceActionButtons()} */}
      {/* <FilterPopover
        menuPosition="bottomLeft"
        defaultValues={defaultValues}
        savedKey={'gFiltersInvoiceList'}
        onApply={() => setFilterParams}
      /> */}
      <ContentContainer.Body>
        {selectedRows && selectedRows.length > 0 && (
          <div className="row">
            {buttonGroups.map((bg) => (
              <div className="col-sm-1">
                <CustomAntButton
                  key={bg.text}
                  text={bg.text + ' (' + selectedRows.length + ')'}
                  fontSizeText={12}
                  iconCn={bg.icon}
                  color={bg.color}
                  antProps={{
                    danger: bg.danger,
                    disabled:
                      bg.text == 'Nhân bản'
                        ? disableCopy
                        : disableChangeStatusRemoveInvoice,
                    type: bg.type ?? 'primary',
                    className: Utils.cn(
                      bg.className,
                      bg.disabled ? 'disabled' : '',
                    ),
                    onClick: bg.onClick,
                  }}
                />
              </div>
            ))}
          </div>
        )}
        <br />
        <CustomDataTable
          columns={dynamicColumns}
          dataSource={invoiceListData}
          isLoading={isGettingListData || isRefetching}
          isClickable
          handleDoubleClickRow={(row) => {}}
          pagination={{
            total: total,
            rowsPerPage: filterParams.limit,
            currentPage: filterParams.page,
            onChangePage: (page) => {
              setFilterParams({
                page,
              })
            },
            onChangeRowsPerPage: (limit) => {
              setFilterParams({
                limit,
                page: 1,
              })
            },
          }}
          isSelectable
          selectedRows={{
            clearSelectedRows: toggledClearRows,
            handleSelectedRows: ({ selectedRows }) => {},
            selectableRowSelected: (row) => _.includes(selectedInvoices, row),
          }}
        />
        <ModalCompanyConfigs
          tvanState={tvanState}
          setTvanState={({ key, value }) => handleChange({ key, value })}
          modalsState={modalsState}
          setModalsState={setModalsState}
          refetchListInvoice={refetchListInvoice}
          row={tvanState.activeRow}
        />
        <ModalCompanyIsDataLog
          modalsState={modalsStateLogBom}
          setModalsState={setModalsStateLogBom}
          refetchListInvoice={refetchListInvoice}
        />
      </ContentContainer.Body>
    </ContentContainer>
  )
}
